export default __webpack_public_path__ + "static/media/StandWeSpeakAndroid.b2559924.webp";